<template>
  <div>
    <vx-card
      title="Фильтры"
      class="p-1 mb-3 passes__filter-card"
      style="background: #e3e6fd"
      collapseAction
    >
      <div class="flex flex-wrap items-center justify-between w-full">
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            :options="countItemsOmPage"
            :clearable="false"
            v-model="countElements"
            style="background-color: #fff"
            placeholder="Количество адресов"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterUsers"
            label="name"
            :options="userStatus"
            :reduce="(name) => name.id"
            :clearable="true"
            placeholder="Все статусы"
            style="background-color: #fff"
            v-model="filter.is_confirmed"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterUsers"
            label="name"
            :options="userRole"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.user_role"
            placeholder="Роль пользователя"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterUsers"
            label="name"
            :options="countyType"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.homes__county_type"
            placeholder="Выбор поселения"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="ФИО"
            v-model="filter.full_name__icontains"
          />
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Телефон"
            v-model="filter.phone__icontains"
          />
        </div>

        <div class="header-filter md:w-4/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер участка"
            v-model="filter.homes__homestead_number"
          />
        </div>
      </div>
    </vx-card>

    <vx-card :title="`Список жителей | Всего ${totalUsers}`" class="p-6">
      <vs-table
        :data="users"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
        id="div-with-loading"
      >
        <template slot="thead">
          <vs-th> # </vs-th>
          <vs-th> Фото </vs-th>
          <vs-th> ФИО </vs-th>
          <vs-th> Участки </vs-th>
          <vs-th> Контакты </vs-th>
          <vs-th> Роль </vs-th>
          <vs-th> Статус </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td>
              <vs-avatar
                v-if="data[indextr].avatar"
                size="large"
                :src="BASE_URL + data[indextr].avatar"
              />
            </vs-td>

            <vs-td :data="data[indextr].full_name">
              {{ data[indextr].full_name }}
            </vs-td>

            <vs-td>
              <template v-if="data[indextr].in_consideration">
                <p class="mb-2">
                  Поселок:
                  <span class="text-primary">{{
                    data[indextr].county_type.name
                  }}</span>
                  <br />
                  Номер участка:
                  <span class="text-primary">{{
                    data[indextr].addresses[0]
                  }}</span>
                </p>
              </template>
              <template v-else>
                <p
                  v-for="(address, index) in data[indextr].homes"
                  :key="index"
                  class="mb-2"
                >
                  {{ index + 1 }}.
                  <span class="text-primary">{{
                    address.county_type.name
                  }}</span
                  >, участок #
                  <span class="text-primary">{{
                    address.homestead_number
                  }}</span
                  >, ул. <span class="text-primary">{{ address.address }}</span>
                </p>
              </template>
            </vs-td>

            <vs-td>
              <p class="mb-2">
                Телефон:
                <a :href="`tel:${data[indextr].phone}`" class="text-primary">{{
                  data[indextr].phone
                }}</a>
              </p>
              <p v-if="data[indextr].email" class="mb-2">
                Email:
                <a
                  :href="`mailto:${data[indextr].email}`"
                  class="text-primary"
                  >{{ data[indextr].email }}</a
                >
              </p>
            </vs-td>

            <vs-td>
              {{ data[indextr].user_role.name }}
            </vs-td>

            <vs-td>
              <template
                v-if="
                  data[indextr].is_confirmed && !data[indextr].in_consideration
                "
              >
                <span class="text-success">Одобрен</span>
              </template>
              <template
                v-else-if="
                  !data[indextr].is_confirmed && !data[indextr].in_consideration
                "
              >
                <span class="text-danger">Отклонен</span>
              </template>
              <template
                v-else-if="
                  !data[indextr].is_confirmed && data[indextr].in_consideration
                "
              >
                <p class="text-primary mb-2">На модерации</p>
                <p v-if="data[indextr].is_active" class="text-success">
                  Телефон подтвержден
                </p>
                <p v-else class="text-danger">Телефон не подтвержден</p>
              </template>
            </vs-td>

            <vs-td>
              <vx-tooltip class="inline-block" text="Подробнее о жителе">
                <vs-button
                  :href="`/residents/${data[indextr].id}`"
                  color="dark"
                  class="text-dark mr-3"
                  icon-pack="feather"
                  icon="icon-eye"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>

              <vx-tooltip
                v-if="data[indextr].in_consideration && data[indextr].is_active"
                class="inline-block"
                text="Модерация пользователя"
              >
                <vs-button
                  @click="moderateUser(data[indextr].id)"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-shield"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>

              <vx-tooltip
                v-if="
                  data[indextr].is_confirmed &&
                  !data[indextr].in_consideration &&
                  data[indextr].is_active
                "
                class="inline-block"
                text="Создать заявку"
              >
                <vs-button
                  @click="openModalCreateNewRequest(data[indextr])"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-clipboard"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>

    <vs-popup
      v-if="userModerate"
      title="Модерация пользователя"
      :active.sync="activeModeratePrompt"
    >
      <div class="loading-wrap vs-con-loading__container">
        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Улица. Например, Ольховая 1"
          name="Улица"
          v-model="userModerate.addresses[0]"
        />
        <span class="text-danger text-sm">{{ errors.first("Улица") }}</span>

        <div class="popup-footer mt-4">
          <vs-button
            @click="confirmUser"
            class="mr-5"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Одобрить заявку</vs-button
          >
          <vs-button @click="rejectUser" color="dark" type="border"
            >Отклонить</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      :title="`Новая заявка на ${userForNewRequest.full_name}`"
      :active.sync="activeCreateNewRequest"
    >
      <new-request :user="userForNewRequest"></new-request>
    </vs-popup>
  </div>
</template>
 
<script>
import {
  API_URL,
  countyType,
  userRole,
  userStatus,
  countItemsOmPage,
} from "@/.env";
import { DateTime } from "luxon";

import NewRequest from "./components/NewRequest";

export default {
  data: () => ({
    BASE_URL: API_URL,
    users: [],
    userRole,
    countyType,
    userStatus,

    activeModeratePrompt: false,
    idModerate: null,
    userModerate: null,

    activeCreateNewRequest: false,
    userForNewRequest: {},

    filter: {
      homes__county_type: "",
      user_role: "",
      full_name__icontains: "",
      phone__icontains: "",
      homes__homestead_number: "",
    },

    countElements: 20,

    currentPagingationPage: 1,
    totalUsers: 0,
    totalPagePagination: 1,
    countItemsOmPage,
  }),
  components: {
    DateTime,
    NewRequest,
  },
  watch: {
    filter: {
      handler(val) {
        this.filterUsers();
      },
      deep: true,
    },
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getAllUsers();
    },
    currentPagingationPage: function () {
      this.getAllUsers();
    },
  },
  computed: {},
  methods: {
    filterUsers: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getAllUsers();
    }, 500),
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getAllUsers() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        let res = (await this.$api.users.getAllUsers(this.filter)).data;

        this.totalUsers = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalUsers / this.countElements
        );

        res.results.forEach((user) => {
          user.county_type = this.countyType.find(
            (x) => x.id == user.county_type
          );

          user.user_role = userRole.find((x) => x.id == user.user_role);

          if (user.homes.length > 0) {
            user.homes.forEach((home) => {
              home.county_type = this.countyType.find(
                (x) => x.id == home.county_type
              );
            });
          }
        });

        this.users = res.results;
        this.$vs.loading.close();
      });
    },
    confirmUser() {
      let payload = {
        address: this.userModerate.addresses[0],
      };

      this.$load(async () => {
        try {
          let res = (
            await this.$api.users.confirmUser(this.idModerate, payload)
          ).data;
          this.notification("Успешно", "Пользователь одобрен", "success");
          this.activeModeratePrompt = false;
        } catch (error) {
          if (error.message == "Request failed with status code 404") {
            this.notification(
              "Ошибка",
              "Адрес неверно введен или не добавлен",
              "danger"
            );
          }
        }
      });
    },
    rejectUser() {
      if (this.idModerate !== null) {
        this.$load(async () => {
          let res = (await this.$api.users.rejectUser(this.idModerate)).data;

          this.notification("Успешно", "Пользователь отклонен", "warning");
        });
      }
      this.activeModeratePrompt = false;
    },
    moderateUser(id) {
      this.activeModeratePrompt = true;
      this.idModerate = id;

      this.userModerate = this.users.find((x) => x.id == id);
    },
    openModalCreateNewRequest(user) {
      this.userForNewRequest = user;
      this.activeCreateNewRequest = true;
    },
  },
  created() {},
  mounted() {
    this.getAllUsers();
  },
};
</script>